import React from 'react';
import { Alert } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { AuthLayout } from '../../../Components/PageLayouts/AuthLayout';
import { RecoveryPasswordFormModule } from '../../../Modules/@Forms/RecoveryPasswordFormModule';

interface Props {}

const RecoveryPasswordPage: React.FC<Props> = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token'); // "testCode"

  return (
    <AuthLayout>
      {!token && <Alert severity="error" sx={{
        fontSize: '10pt'
      }}>Token missing in url. Please to check your mail.</Alert>}
      {token && <RecoveryPasswordFormModule token={token} />}
    </AuthLayout>
  );
};

export default RecoveryPasswordPage;
